const toOptional = (value: string | undefined) =>
  value && value.length > 0 ? value : undefined;

export const env = {
  apiBaseUrl: toOptional(import.meta.env.VITE_API_BASE_URL) ?? '/api',
  auth0Domain: toOptional(import.meta.env.VITE_AUTH0_DOMAIN),
  auth0ClientId: toOptional(import.meta.env.VITE_AUTH0_CLIENT_ID),
  auth0Audience: toOptional(import.meta.env.VITE_AUTH0_AUDIENCE),
  auth0Scope: toOptional(import.meta.env.VITE_AUTH0_SCOPE) ?? 'openid profile email',
} as const;
